import { render, staticRenderFns } from "./C_App_GlobalNotification.vue?vue&type=template&id=e962f914&scoped=true&"
import script from "./C_App_GlobalNotification.vue?vue&type=script&lang=js&"
export * from "./C_App_GlobalNotification.vue?vue&type=script&lang=js&"
import style0 from "./C_App_GlobalNotification.vue?vue&type=style&index=0&id=e962f914&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e962f914",
  null
  
)

export default component.exports